export const IconMinus: {
  name: 'icon_minus-c6b6bce44098'
} = {
  name: 'icon_minus-c6b6bce44098'
}
